import { Box, Typography, Button, LinearProgress } from "@mui/material"
import DropFiles from "../../../../shared/components/DropFiles"
import { useTheme } from '@mui/material/styles';
import { useLocations } from "../../../../shared/context/locationsContext";
import { CloudUpload as CloudUploadIcon, Download as DownloadIcon } from '@mui/icons-material';
import { useEffect } from "react";
export default function ListMasiveComponent() {
    const theme = useTheme();
    const { loadMasiveLocations, dataMasive, responseMasive, loadingMasive, processMasiveLocations, loadingUploadMasive, setDataMasive, setResponseMasive } = useLocations()

    useEffect(() => {
        return () => {
            setDataMasive(null)
            setResponseMasive(null)
        };
    }, []);

    return (
        <Box sx={{ padding: '20px' }}>
            <DropFiles onChange={(files) => loadMasiveLocations(files)} />


            <Box sx={{
                display: 'flex',
                alignItems: 'center',
                gap: 2,
                marginTop: 2,
                marginBottom: 3,
                padding: 2,
                backgroundColor: theme.palette.background.paper,
                borderRadius: 1,
                boxShadow: '0 1px 3px rgba(0,0,0,0.12)'
            }}>
                <Box>
                    <Typography variant="subtitle1" sx={{ fontWeight: 500, color: theme.palette.text.primary }}>
                        ¿Primera vez cargando ubicaciones?
                    </Typography>
                    <Typography variant="body2" sx={{ color: theme.palette.text.secondary }}>
                        Descarga la plantilla Excel para cargar tus ubicaciones masivamente
                    </Typography>
                </Box>
                <Button
                    variant="outlined"
                    href="https://operacionessistema.s3.us-west-2.amazonaws.com/plantillas/LOCATIONS.xlsx"
                    target="_blank"
                    endIcon={<DownloadIcon />}
                    sx={{
                        minWidth: '140px',
                        '&:hover': {
                            backgroundColor: theme.palette.primary.main,
                            color: theme.palette.primary.contrastText
                        }
                    }}
                >
                    Descargar Plantilla
                </Button>
            </Box>

            <Box sx={{ marginTop: '20px' }} >
                <Button disabled={!dataMasive || loadingMasive} variant="contained" color="primary" onClick={processMasiveLocations} startIcon={<CloudUploadIcon />}
                >
                    {loadingUploadMasive ? 'Cargando...' : 'Procesar y cargar (' + (dataMasive?.length || 0) + ' ubicaciones)'}
                </Button>
            </Box>

            {loadingMasive && (
                <Box sx={{ marginTop: '20px' }}>
                    <LinearProgress />
                </Box>
            )}

            {/* Results display section */}
            {responseMasive && (
                <Box sx={{ marginTop: '30px', border: `1px solid ${theme.palette.divider}`, borderRadius: '8px', padding: '20px' }}>
                    <Typography variant="h6" gutterBottom>
                        Resultados de la carga
                    </Typography>

                    <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: '20px', marginBottom: '20px' }}>
                        <Box sx={{
                            padding: '15px',
                            borderRadius: '8px',
                            backgroundColor: theme.palette.success.light,
                            minWidth: '200px'
                        }}>
                            <Typography variant="subtitle1">Ubicaciones creadas</Typography>
                            <Typography variant="h4">{responseMasive.created.length}</Typography>
                        </Box>


                    </Box>

                    {/* Error lists */}
                    {responseMasive.not_created.length > 0 && (
                        <Box sx={{ marginTop: '20px' }}>
                            <Typography variant="subtitle1" color="error" gutterBottom>
                                Ubicaciones no creadas ({responseMasive.not_created.length})
                            </Typography>
                            <Box sx={{
                                maxHeight: '200px',
                                overflowY: 'auto',
                                border: `1px solid ${theme.palette.divider}`,
                                borderRadius: '4px'
                            }}>
                                {responseMasive.not_created.map((item, index) => (
                                    <Box key={index} sx={{
                                        padding: '10px',
                                        borderBottom: index < responseMasive.not_created.length - 1 ? `1px solid ${theme.palette.divider}` : 'none',
                                        backgroundColor: index % 2 === 0 ? theme.palette.action.hover : 'transparent'
                                    }}>
                                        <Typography variant="body2" fontWeight="bold">
                                            {item.location?.name || 'Sin nombre'} ({item.location?.code || 'Sin código'})
                                        </Typography>
                                        <Typography variant="body2" color="error">
                                            Error: {item.message}
                                        </Typography>
                                    </Box>
                                ))}
                            </Box>
                        </Box>
                    )}


                </Box>
            )}
        </Box>
    )
}